export const DOMAIN_ORDER = ['abstraction', 'change', 'relation'] as const
export type AiqDomain = (typeof DOMAIN_ORDER)[number]

export const TYPE_MAP: Record<AiqDomain, string> = { abstraction: '무시', change: '변화', relation: '관계' }
export const TYPE_POWER_MAP: Record<AiqDomain, string> = { abstraction: '통찰력', change: '추리력', relation: '연결력' }

export type MathBand = 'high' | 'mid' | 'low'

/**
 * AIQ 지수(aiqScore) → 수학머리 상/중/하 밴딩.
 * DRAFT_DOCS:209 — 상(≥115) / 중(85≤x<115) / 하(x<85). 라벨은 i18n(report.mathHead.band.*).
 */
export function bandOf(aiqScore: number): MathBand {
  if (aiqScore >= 115) return 'high'
  if (aiqScore >= 85) return 'mid'
  return 'low'
}

// 색 토큰 (brainstorming 색 A — 네이비 앵커, ②③ 통일)
export const COHORT_COLORS = { self: '#31418F', sameAge: '#5AC6C8', quebon: '#5E86FF' } as const
export const MAIN_BLUE = '#5E86FF'

// §6.2 슬로건/정의 (verbatim; <strong>/<span>/<br/>는 렌더 시 강조/줄바꿈)
export const DOMAIN_SLOGAN: Record<AiqDomain, string> = {
  abstraction: '중요하지 않은 내용을 무시하여 본질을 꿰뚫는 통찰력!',
  change: '차이를 통해 변화를 관찰하여 규칙을 찾아내는 추리력!',
  relation: '비교를 통해 주어진 요소 사이의 관계를 찾아내는 연결력!',
}
export const DOMAIN_DEFINITION: Record<AiqDomain, string> = {
  abstraction: '무시는 문제 해결 과정에서 중요하지 않은 것을 무시하여 핵심에 집중하는 능력입니다. 문제의 본질을 꿰뚫는 이러한 통찰력은 미래 시대의 인재라면 당연히 갖추고 있어야 할 것입니다.',
  change: '변화는 문제 해결 과정에서 주어진 요소의 차이를 통해 변화를 관찰하여 규칙을 찾아내는 능력입니다. 변화무쌍한 시대를 살아갈 사람들에게 이러한 추리력은 반드시 빛을 발하게 될 역량이 될 것입니다.',
  relation: '관계는 문제 해결 과정에서 비교를 통해 주어진 요소 사이의 관계를 찾아내는 능력입니다. 네트워크가 중요한 시대를 살아갈 사람들에게 이러한 연결력은 매우 필요한 역량이 될 것입니다.',
}

/** 점수차 문구 (뷰 스펙 §6.3) — 큐레이션 narrative 레이어(백엔드 content와 동급, UI 크롬 아님). 결정적. */
export function scoreDiffText(score: number | null, sameAgeScore: number): string {
  if (score == null) return '동일합니다.'
  const diff = score - sameAgeScore
  if (diff > 0) return `${diff}점 높습니다.`
  if (diff < 0) return `${Math.abs(diff)}점 낮습니다.`
  return '동일합니다.'
}
